import { Link } from 'react-router-dom';
import useTutorReviews from '../hooks/useTutorReviews';

const TutorsList = ({ profesori }) => {
  const { getReviewText, getStars } = useTutorReviews();

  // helper (van ili unutar komponente)
  const getNacinNastave = (value) => {
    if (value === null || value === undefined || value === "" || value === "null") return "Online";
    const v = Number(value);
    if (v === 0) return "Online";
    if (v === 1) return "Uživo";
    if (v === 2) return "Uživo i online";
    return "Online"; // fallback
  };

  return (
    <div className="row justify-content-center">
      {profesori.map((profesor) => (
        <div key={profesor.id_korisnika} className="tutor-box d-flex">
          <div className="rec">
            <img
              src={profesor.img && profesor.img.trim() !== '' ? profesor.img : '/assets/images/user.png'}
              onError={(e) => { e.target.src = '/assets/images/user.png'; }}
              alt={profesor.ime || 'Profesor'}
              className="rounded-circle"
            />

            <div className="tx-l">
              {getStars(profesor.prosjecnaOcjena)}
              <p className="upper">{getReviewText(profesor.brojRecenzija)}</p>
              {profesor.verifikovan === 1 && <i className="bi bi-patch-check-fill"></i>}
            </div>
          </div>

          <div className="info">
            <h3>{profesor.ime}</h3>

            <div className="d-flex align-items-baseline">
              <h4>Cijena:</h4>
              <p style={{ marginLeft: '10px' }}>{profesor.cijena}€ - 60min</p>
            </div>

            <h4>Predmeti:</h4>
            <div className="d-flex w-flex">
              {(profesor.predmeti || []).map((predmet, index) => (
                <span key={index} className="upper">{predmet}</span>
              ))}
            </div>

            {/* DODATO: Način nastave ispod Predmeti */}
            <h4>Način nastave:</h4>
            <div className="d-flex w-flex">
              <span className="upper">{getNacinNastave(profesor?.nacin_nastave)}</span>
            </div>
          </div>

          <div className="bio">
            <h4>Biografija</h4>
            <p>
              {(profesor.biografija || '')
                .split(' ')
                .slice(0, 12)
                .join(' ') + (profesor.biografija ? '...' : '')}
            </p>

            <Link to={`/profesori/${encodeURIComponent((profesor.ime || '').trim().toLowerCase().replace(/\s+/g, '-'))}-${profesor.id_korisnika}`}
            className="btn-tutor">
              VIDI PROFESORA
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TutorsList;